<template>
    <div>
        <h2 class="no-margin mb-10">{{ $t('add_content') }}</h2>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('dashboard') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('add_content') }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="line"></div>
        <Add />
    </div>
</template>

<script>
import Add from '../components/addContent/Add'
export default {
  components: {
    Add
  }
}
</script>

<style lang="scss" scoped>

</style>
